import React, {useEffect, useState} from "react";
import styles from "./index.module.css";
import {Button, Flex, Image, useTheme} from "@aws-amplify/ui-react";
import {AiOutlineClose} from "react-icons/ai";
import {Link, useLocation} from "react-router-dom";
import Drawer from "react-modern-drawer";
import img1 from '../../assets/images/01-video.png';
import img2 from '../../assets/images/02-magazine.png';
import img3 from '../../assets/images/03-for-kids.png';
import img4 from '../../assets/images/04-webinar.png';
import {getCourses} from "../../data/api";


export default function CoursesMenu(
  {
    courseMenuOpen = false,
    setCourseMenuOpen
  }
) {
  const [courses, setCourses] = useState(null)

  const getCourseImage = courseId => {
    switch (courseId) {
      case 3199:
        return img1;
      case 3200:
        return img2;
      case 3201:
        return img3;
      default:
        return img4;
    }
  }

  useEffect(() => {
    const courses = async () => {
      await getCourses().then(res => {
        const {data = []} = res ?? {}
        setCourses(data)
      })
    }
    courses()
  }, []);

  const {tokens} = useTheme();

  const location = useLocation();
  const {pathname = ""} = location || {};
  const courseId = pathname.split("/")[2]

  console.log("courses: ", courses)

  return (
    <Drawer
      duration={300}
      open={courseMenuOpen}
      onClose={() => setCourseMenuOpen(false)}
      direction='left'
      className={styles.coursesMenu}
    >
      <Flex
        gap="0"
        wrap="wrap"
        width="100%"
        height="100%"
        direction="column"
        alignItems="stretch"
        alignContent="stretch"
        justifyContent="flex-start"
      >
        <Flex
          height="90px"
          direction="row-reverse"
          padding={tokens.space.large}
          className={styles.coursesMenuCloseWrapper}
        >
          <Button
            className={styles.iconButton}
            onClick={() => setCourseMenuOpen(false)}
          >
            <AiOutlineClose/>
          </Button>
        </Flex>
        {(courses || []).sort((a, b) => {
          return a.order - b.order;
        }).map(course => {
          return (
            <Link
              onClick={() => setCourseMenuOpen(false)}
              to={`/corsi/${course.id}`}
              className={styles.coursesMenuLink}
            >
              <Image
                alt={course.title}
                src={getCourseImage(course.id)}
                className={courseId === course.id.toString() ? styles.coursesMenuImageActive : styles.coursesMenuImage}
              />
            </Link>
          )
        })}
      </Flex>
    </Drawer>
  );
}
